module.exports = __webpack_public_path__ + "img/UTFREM-6.028752f5.jpg";